import { PersistentStorage as BasePersistentStorage } from "./_persistent-storage";

export class PersistentStorage extends BasePersistentStorage {}
